module.exports = __webpack_public_path__ + "static/media/sn.b03558dd.svg";